(() => {
  const renderingPriceBlocks = new WeakMap();

  function formatMoney(cents) {
    const moneyFormat = window.theme?.settings?.money_with_currency_format;

    if (moneyFormat && typeof window.formatPrice === 'function') {
      return window.formatPrice(moneyFormat, cents / 100);
    }

    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    });
  }

  function getConfigs() {
    return [...document.querySelectorAll('script[id^="AutomaticDiscountDisplay-"]')]
      .map(script => {
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          return null;
        }
      })
      .filter(Boolean);
  }

  function getCurrentVariantId(sectionId) {
    const productFormInput = document.querySelector(`#ProductForm-${sectionId} [name="id"]`);
    const productSelectorInput = document.querySelector(`product-selector[data-section-id="${sectionId}"] [name="id"]`);
    const selectedVariant = new URLSearchParams(window.location.search).get('variant');

    return productFormInput?.value || productSelectorInput?.value || selectedVariant;
  }

  function buildPriceHtml(variantPrice, saleLabel) {
    const saleBadge = saleLabel
      ? `<span class="text-navigation-button sale">${saleLabel}</span>`
      : '';

    return `
      <div class="price__sale${saleBadge ? ' price__sale--has-badge' : ''}">
        <div class="price__sale-inner">
          <span class="visually-hidden">Regular price</span>
          <del>${formatMoney(variantPrice.regularPrice)}</del>
          <span class="visually-hidden">Sale price</span>
          <ins>${formatMoney(variantPrice.discountedPrice)}</ins>
        </div>
        ${saleBadge}
      </div>
    `;
  }

  function renderRechargeOptionPrices(productPrice, variantPrice) {
    productPrice.querySelectorAll('[data-price-onetime], .rc_widget__price--onetime').forEach(price => {
      price.innerHTML = `<del>${formatMoney(variantPrice.regularPrice)}</del> <ins>${formatMoney(variantPrice.discountedPrice)}</ins>`;
    });
  }

  function renderConfig(config) {
    const productPrice = document.querySelector(`#Product-Price-${config.sectionId}`);
    if (!productPrice || renderingPriceBlocks.get(productPrice)) return;

    const variantId = getCurrentVariantId(config.sectionId);
    const variantPrice = config.variants?.[variantId] || Object.values(config.variants || {})[0];

    if (!variantPrice || variantPrice.discountedPrice >= variantPrice.regularPrice) return;

    const priceBlock = productPrice.querySelector('.product__price') || productPrice;
    const price = priceBlock.querySelector('.price');
    const priceContainer = priceBlock.querySelector('.price__container') || price;

    if (!price || !priceContainer) return;

    productPrice.dataset.automaticDiscountDisplay = '';
    productPrice.dataset.regularPrice = variantPrice.regularPrice;
    productPrice.dataset.discountedPrice = variantPrice.discountedPrice;
    priceBlock.dataset.automaticDiscountDisplay = '';
    priceBlock.dataset.regularPrice = variantPrice.regularPrice;
    priceBlock.dataset.discountedPrice = variantPrice.discountedPrice;

    const expectedHtml = buildPriceHtml(variantPrice, config.saleLabel);
    renderingPriceBlocks.set(productPrice, true);
    price.classList.add('price--on-sale');
    priceContainer.innerHTML = expectedHtml;
    renderRechargeOptionPrices(productPrice, variantPrice);
    setTimeout(() => renderingPriceBlocks.delete(productPrice));
  }

  function renderAll(configs) {
    configs.forEach(renderConfig);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const configs = getConfigs();
    if (configs.length === 0) return;

    renderAll(configs);

    document.addEventListener('change', event => {
      if (event.target.matches('[name="id"], [name="selling_plan"], .rc_widget__option__input')) {
        setTimeout(() => renderAll(configs), 0);
        setTimeout(() => renderAll(configs), 250);
      }
    });

    const observer = new MutationObserver(() => {
      renderAll(configs);
    });

    document.querySelectorAll('[data-main-product]').forEach(product => {
      observer.observe(product, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
      });
    });

    [100, 300, 600, 1000, 2000, 4000].forEach(delay => {
      setTimeout(() => renderAll(configs), delay);
    });
  });
})();
